import { render, staticRenderFns } from "./carAddParkingSpaceList.vue?vue&type=template&id=04b2f6fa&scoped=true"
import script from "./carAddParkingSpaceList.vue?vue&type=script&lang=js"
export * from "./carAddParkingSpaceList.vue?vue&type=script&lang=js"
import style0 from "./carAddParkingSpaceList.vue?vue&type=style&index=0&id=04b2f6fa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04b2f6fa",
  null
  
)

export default component.exports